import { useEffect, useState } from 'react';
import { useAuth0, User } from '@auth0/auth0-react';
import { Avatar, Button, Popover, Switch, Tooltip } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { FlexCol, FlexRow } from '../common/common';
import { ARYBALLE_COLOR_CYAN, ARYBALLE_COLOR_GRAY, colorHexToRGBA, getUserSub } from '../../utils/helpers/utils';
import { apiPostUser } from '../../services/api/api';
import { Link } from 'react-router-dom';

export const LogoutWidget = () => {
  const { user, isAuthenticated, getAccessTokenSilently, logout, loginWithRedirect } = useAuth0();
  const [accessToken, setAccessToken] = useState<string | undefined>();
  const [userInfo, setUserInfo] = useState<User | null>(null);

  let logoutURI = window.location.origin + '/signout/callback';
  if (user?.idp_logout_uri) {
    logoutURI = user.idp_logout_uri;
  }

  useEffect(() => {
    getAccessTokenSilently().then((token) => {
      setAccessToken(token);
    });
  }, [getAccessTokenSilently]);

  useEffect(() => {
    if (!user || !isAuthenticated) setUserInfo(null);
    else setUserInfo(user);
  }, [isAuthenticated, user]);

  useEffect(() => {
    if (!accessToken || userInfo === null) {
      return;
    }
    if (isAuthenticated && userInfo && userInfo.email) {
      const userId = userInfo.sub ? getUserSub(userInfo.sub) : '';
      apiPostUser(userId, userInfo.email, userInfo.given_name ?? '', userInfo.family_name ?? '', userInfo.assigned_groups as string[]).then((res) => {
        console.log('api: post user ok', res);
      });
    }
  }, [accessToken]);

  return (
    <Popover
      trigger="click"
      placement="bottomRight"
      content={
        <FlexCol style={{ gap: 3, justifyContent: 'center', alignItems: 'center' }}>
          {userInfo && isAuthenticated && (
            <FlexCol style={{ alignItems: 'stretch', gap: 1 }}>
              <FlexCol style={{ gap: 1, alignItems: 'center' }}>
                <b>{userInfo.name}</b>
                <i>{userInfo.email}</i>
              </FlexCol>
              <FlexRow>
                <Link to="/profile">
                  <Button block>Profile</Button>
                </Link>
                <Button type="primary" block onClick={() => logout({ logoutParams: { returnTo: logoutURI, federated: true } })}>
                  Logout
                </Button>
              </FlexRow>
            </FlexCol>
          )}
        </FlexCol>
      }
    >
      <Tooltip placement="left" overlay={isAuthenticated && userInfo && <>Logged in as {userInfo.name}</>}>
        <Avatar
          size="large"
          style={{
            backgroundColor: isAuthenticated ? colorHexToRGBA(ARYBALLE_COLOR_CYAN, 1) : colorHexToRGBA(ARYBALLE_COLOR_GRAY, 0.7),
            cursor: 'pointer',
          }}
          icon={<UserOutlined />}
        />
      </Tooltip>
    </Popover>
  );
};
